<script lang="ts" setup>
import { PropType } from 'vue'
import { pascalCase } from 'scule'

export type IconName =
  | 'arrow-left'
  | 'alert'
  | 'arrow-regular-top'
  | 'audio-book'
  | 'book'
  | 'books'
  | 'calendar'
  | 'calendar-alt'
  | 'cart'
  | 'chat'
  | 'check'
  | 'combo'
  | 'contact'
  | 'course'
  | 'delete'
  | 'download'
  | 'dropdown'
  | 'duplicate'
  | 'ebook'
  | 'edit'
  | 'ellipse'
  | 'facebook'
  | 'document'
  | 'folder'
  | 'hide'
  | 'info'
  | 'large-arrow'
  | 'large-close'
  | 'link-alt'
  | 'link-arrow'
  | 'linkedin'
  | 'map'
  | 'media'
  | 'media-play'
  | 'mini-arrow-down'
  | 'mini-arrow-up'
  | 'mini-arrow-dropdown'
  | 'mini-arrow-link'
  | 'mini-arrow-regular'
  | 'mini-arrow-slider-left'
  | 'mini-arrow-slider-right'
  | 'mini-arrow-thin'
  | 'mini-bullet'
  | 'mini-check'
  | 'mini-checkbox'
  | 'mini-close-medium'
  | 'mini-close-small'
  | 'mini-dropdown'
  | 'mini-minus-small'
  | 'mini-plus-small'
  | 'mini-small'
  | 'mobile-menu'
  | 'modules'
  | 'notification'
  | 'offers'
  | 'pin'
  | 'pricelist'
  | 'product'
  | 'profile'
  | 'search'
  | 'settings'
  | 'show'
  | 'showcases'
  | 'social-blog'
  | 'social-facebook'
  | 'social-instagaram'
  | 'social-linkedin'
  | 'social-twitter'
  | 'social-xing'
  | 'social-youtube'
  | 'textlink'
  | 'twitter'
  | 'user-work'
  | 'upload'
  | 'warning'
  | 'web'
  | 'youtube'
  | 'arrow-regular-left-mobile'
  | 'arrow-regular-right-mobile'
  | 'arrow-bend-right-down-large'
  | 'set'
  | 'blog'
  | 'instagram'
  | 'spotify'
  | 'floorplan'
  | 'image-icon'

defineProps({
  name: {
    type: String as PropType<IconName>,
    default: 'arrow-left',
  },
})
</script>

<template>
  <component :is="pascalCase(name)" aria-hidden="true" role="graphics-symbol" />
</template>
